import {BaseComponent} from "../../../../components/BaseComponent";
import React from "react";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {createStructuredSelector} from "reselect";
import {connect} from "react-redux";
import {HBox, VBox} from "../../../../components/Box";
import {REQUEST_VAT_CODES} from "../../constants";
import {Dropdown} from "../../../../components/Dropdown";
import {FormField} from "../../../../components/FormFields";
import {Input} from "../../../../components/Form";
import {getVatCodes} from "../../actions";
import {selectVatCodes} from "../../selectors";
import {selectWorks} from "../../../Api/selectors";
import {Loader} from "../../../../components/Loader";

class SubjectVatFormComp extends BaseComponent {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getVatCodes();
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => {
      return { value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` };

    });
  }

  get amount() {
    return this.props?.subjectVat?.amount ?? '';
  }

  get code() {
    return this.props?.subjectVat?.code ?? '';
  }

  onVatCodeChange(evt) {
    const { value } = evt;
    this.props.onChange('code', value);
  }

  onInputChange(evt) {
    this.props.onChange(evt.target.name, this.sanitizeValue(evt.target.value));
  }

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <HBox>
        <VBox>
          <p>{this.lbl('invoice.create.vat')}</p>
          <FormField>
            <Dropdown options={this.vatCodeOptions} value={this.code} onChange={this.onVatCodeChange.bind(this)} />
          </FormField>
        </VBox>
        <VBox>
          <p>{this.lbl('invoice.vat.amount')}</p>
          <FormField>
            <Input
              name="amount"
              disabled={true}
              value={this.amount ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      </HBox>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vatCodes: selectVatCodes(),
    work: selectWorks([REQUEST_VAT_CODES])
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getVatCodes() {
      dispatch(getVatCodes());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SubjectVatForm = compose(
  withConnect,
  withRouter,
)(SubjectVatFormComp);
